<template>
  <div
    id="squareboxbackground"
    class="squareboxbackground-section"
  >
    <img
      v-if="section.background_image"
      :src="section.background_image.url"
      alt=""
    >
    <div class="container">
      <div class="col-7">
        <h2
          class="banner-text"
          v-html="section.title"
        />
        <div class="squarebox">
          <div
            class="content"
            v-html="section.content"
          />
          <div class="button-holder">
            <a
              :href="section.link.url"
              :target="section.link.target"
              class="link btn"
            >
              {{ section.link.title }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stripBlockTags from '@/utils/strip-block-tags';

export default {
  name: 'BannerLikeSection',

  props: {
    section: { type: Object, required: true }
  },

  methods: {
    stripBlockTags
  }
};
</script>

<style lang="scss" scoped>
.squareboxbackground-section {
  display: flex;
  justify-content: center;
  padding: 0;
  position: relative;

  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }

  .container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    padding-bottom: 50px !important;
    padding-top: 50px !important;
    padding-left: 0;

    .col-7 {
      border: #040404 solid 6px;
      background-color: #ffffff;
      padding: 15px;
      margin: 0;

      @media screen and (min-width: $breakpoint-sm) {
        padding: 62px;
      }

      .banner-text {
        padding: 0;
      }
    }
  }

  @media screen and (min-width: $breakpoint-md) {
    padding: 0;
  }

  h2::v-deep {
    font-size: 48px !important;
    line-height: 48px !important;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    margin: 0;
    margin-bottom: 30px !important;
    padding: 0 62px;

    strong {
      color: $thd-orange;
    }
  }

  .squarebox {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .content {
      font-size: 24px;
      line-height: 36px;
      font-weight: 400;
      color: #040404;
    }
  }
}
</style>
